import React, { useEffect, useState } from 'react';

import ListWrapper from './list-wrapper';

const CreatedListItem = ({ text, handleRemove, index }) => {
  return (
    <li className="c-letter-slide-list__item">
      <span>{text}</span>
      <button
        onClick={handleRemove}
        aria-label={`Ta bort svarsalternativ nummer ${index + 1}`}
      />
    </li>
  );
};

const CreateList = ({ initialData, onUpdate }) => {
  const [listAlternatives, setListAlternatives] = useState(initialData);
  const [newItem, setNewItem] = useState('');

  const handleInputChange = (e) => {
    setNewItem(e.target.value);
  };

  const handleRemove = (indexToRemove) => {
    setListAlternatives((prevList) =>
      prevList.filter((_, index) => index !== indexToRemove)
    );
  };

  const handleAddClick = () => {
    if (newItem?.trim()) {
      setListAlternatives([...listAlternatives, newItem]);
      setNewItem('');
    }
  };

  useEffect(() => {
    onUpdate(listAlternatives);
  }, [listAlternatives]);

  return (
    <ListWrapper
      newItem={newItem}
      hasSingleItem={listAlternatives?.length === 1}
      handleInputChange={handleInputChange}
      handleAddClick={handleAddClick}
      placeholderText="Skriv in ett alternativ"
      ariaLabel="Fyll i ett checkbox-alternativ"
    >
      {listAlternatives?.map((text, i) => (
        <CreatedListItem
          key={i}
          text={text}
          index={i}
          handleRemove={() => handleRemove(i)}
        />
      ))}
    </ListWrapper>
  );
};

export default CreateList;
